import { Injectable, Injector } from '@angular/core';
import { Adiantamento, BaseResourceService, ContratoRemanejo } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LicitacaoRemanejoService extends BaseResourceService<ContratoRemanejo> {

    constructor(
        protected injector: Injector
    ) {
        super(`licitacao-remanejos`, injector);
    }

    public salvarLista(remanejos: ContratoRemanejo[]): Observable<ContratoRemanejo[]> {
        return this.http.post(`${this.login.cidade.id}/${this.api}/salvar-lista`, remanejos, this.httpOptions()).pipe(
            map(res => res),
            catchError(err => this.handleError(err))
        );
    }
}
